import { render, staticRenderFns } from "./DCUDownload.vue?vue&type=template&id=131b1124&scoped=true&"
import script from "./DCUDownload.vue?vue&type=script&lang=js&"
export * from "./DCUDownload.vue?vue&type=script&lang=js&"
import style0 from "./DCUDownload.vue?vue&type=style&index=0&id=131b1124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131b1124",
  null
  
)

component.options.__file = "DCUDownload.vue"
export default component.exports